export default __webpack_public_path__ + "static/media/80s_bg_right@2x.1a346227.jpg";